export const addEditGeneralInfoValidation = {
  streetNumber: [{ required: true, message: 'House number is required!' }],
};
